import SaveIcon from "assets/icon/SaveIcon"

export default function SaveButton(props){
    return(
        <button className={`button flex gap-2 ${ props?.visible ? 'block' : 'hidden' } hover:shadow-lg hover:opacity-85 items-center`} onClick={props?.onClick}>
            <SaveIcon className="fill-white w-4" />
            <span>Save</span>
        </button>
    )
}